import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {PredictionsWidgetConfig} from "./predictions-widget.config";
import {PredictionsWidgetStore} from "./predictions-widget.store";
import {PredictionsWidgetHandlers} from "./handlers/predictions-widget.handlers";
import {FullGameResponseDomainService} from "../../domain/full-game/services/full-game-response.domain-service";

export class PredictionsWidgetController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, PredictionsWidgetConfig, PredictionsWidgetStore, PredictionsWidgetHandlers, FullGameResponseDomainService];
}
